import React from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import api from "../../../api/api";
import { fetchUser } from "../../../features/userBlock/userBlockSlice";
import Images from "../../../media/images";
import { toast } from 'react-toastify'
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";
import EditUser from "./ViewUser";

const DirectUserCreate = () => {
  const users = useSelector((state) => state.userBlock.users);
  const [change, setChange] = useState(false)
  const [user, setUser] = useState(0)
  // console.log("check", users);
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchUser());
  }, [dispatch, change]);

  const printRef = useRef(null)
  const print = useReactToPrint({
    content: () => printRef.current,
  });


  const handlePassive = (id) => {
    // console.log(id)s
    // alert(id)
    api.patch(`/users/${id}/deactivate/`)
      .then(response => {
        setChange(!change)
        toast.success("Deactivate ")
      }).catch(error => {
        toast.error("something went wrong")
      })
  }

  const handleActive = (id) => {
    api.patch(`/users/${id}/activate/`)
      .then(response => {
        setChange(!change)
        toast.success("Activate")
      }).catch(error => {
        toast.error("something went wrong")
      })
  }



  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Direct User Create List
      </h1>
      <div className="">
        <img src={Images.title_border} alt="" className="mx-auto mt-4" />
      </div>
      {/* table  */}
      <div className="mt-3 w-full md:px-10">
        <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
              <div className="overflow-hidden">
                <table ref={printRef} className="border-primary-blue min-w-full border text-center">
                  <thead className="font-Bree bg-primary-red text-lg font-bold">
                    <tr className="">
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        SN.
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Create Date
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        User Name
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Address
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Contact No
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        User Id
                      </th>
                      {/* <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Password
                      </th> */}
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="font-Acme">
                    {users?.map((item, index) => {

                      return (
                        <tr className="border-primary-blue border-2 bg-white">
                          <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                            {item.id}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                            {item.created_at.split('T')[0]}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                            {item.profile.f_name}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                            {/* Bharatpur-11 */}
                            {item.address ?? "Address Not Mention"}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                            {item.phone}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                            {item.id}
                          </td>
                          {/* <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                            {item.password}
                          </td> */}
                          <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                            <button
                               data-bs-toggle="modal"
                               data-bs-target="#exampleModalEdit"
                               onClick={()=>{setUser(item.profile.id)}}
                              className="bg-primary-green rounded-full p-1 px-2 text-white"
                            >
                              View
                            </button>
                            <EditUser user={user}/>
                            <button
                              onClick={() => handlePassive(item.id)}
                              className="bg-primary-red rounded-full p-1 px-2 text-white"
                            >
                              Passive

                            </button>
                            <button
                              onClick={() => handleActive(item.id)}
                              className="bg-primary-blue rounded-full p-1 px-2 text-white"
                            >
                              Active

                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <div className="mt-5 flex items-center justify-end gap-10">
                  <div className="bg-primary-green font-Berkshire rounded-md px-5 py-3 font-bold text-white">
                    <button onClick={print} href="">Print List</button>
                  </div>

                  <div className="bg-primary-blue rounded-md px-5 py-3 font-bold text-white">
                    <button
                    
                    >View More</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end table */}
    </div>
  );
};

export default DirectUserCreate;
